// extracted by mini-css-extract-plugin
export default {"vendorQuestion":"vendorQuestion__ZWY1O","hed":"hed__Njk2Z","content":"content__MGM3M","chips":"chips__NWQ2O","chip":"chip__MTNhZ"};